import { IAppAction } from "../appAction";

export const adsActions = {
  FETCH_SLOTS: "FETCH_SLOTS",
  FETCH_SLOTS_SUCCESS: "FETCH_SLOTS_SUCCESS",
  FETCH_SLOTS_ERROR: "FETCH_SLOTS_ERROR",
};

export const fetchSlots = (): IAppAction => ({
  type: adsActions.FETCH_SLOTS
});

export const fetchSlotsSuccess = (payload: string[]): IAppAction => ({
  type: adsActions.FETCH_SLOTS_SUCCESS,
  payload
});

export const fetchSlotsError = (error: Error): IAppAction => ({
  type: adsActions.FETCH_SLOTS_ERROR,
  payload: error
});
